
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import submitIcon from '../pics/submitIc.PNG';
import inprogressIcon from '../pics/inprogressIc.PNG';
import readyIcon from '../pics/readyIc.PNG';
import collectedIcon from '../pics/collectedIc.PNG';
import cancelledIcon from '../pics/cancelledIc.PNG';
import deliveredIcon from '../pics/collectedIc.PNG';
import Select from 'react-select';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getOrderDetails, getOrderStatuses, getAllSubscriptions, getUserDeviceToken, handleRealTimeUpdate } from '../Utils/Utils';
import { LayoutDashboard, Menu } from 'lucide-react';
import axios from 'axios';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Pusher from 'pusher-js';

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

class Orderdetails extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        const webpush = require('web-push');
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            comments: '',
            loadweights: '',
            customername: '',
            customerid: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            gender: "",
            token: "",
            notes: '',
            role: "",
            city: "",
            area: "",
            userid: "",
            orderdetails: [],
            orderstatuses: [],
            orderCount: 0,
            orderid: "",
            page: '',
            selectedOrderStatus: '',
            status: '',
            strStats: '',
            laststatus: 'Submitted',
            statusOptions: '',
            userstatus: '',
            registrationdate: '',
            allsubscriptions: [],
            deviceToken: "",
            userDeviceToken: "",
            deviceToken: "",
            dashboardtype:'',
            dashboardOrderType:'',
        }
    }

    vapidPublicKey = 'BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE';
    firebaseConfig = {
        apiKey: "AIzaSyA-s0TGFcE_sIPV6YSjNJk8clTPiMCz7UU",
        authDomain: "iwash-laundry-2d327.firebaseapp.com",
        projectId: "iwash-laundry-2d327",
        storageBucket: "iwash-laundry-2d327.firebasestorage.app",
        messagingSenderId: "361330789184",
        appId: "1:361330789184:web:106c241e45f338be0c08a5"
    };

    app = initializeApp(this.firebaseConfig);
    messaging = getMessaging(this.app);
    isEnrollingNotification = false;

    orderStatus = [
        { label: "Cancelled", value: "Cancelled" },
        { label: "Collected", value: "Collected" },
        { label: "Delivered", value: "Delivered" },
        { label: "In store", value: "In Store" },
        { label: "Processing", value: "Processing" },
        { label: "Ready to collect", value: "Ready to collect" },
    ]

    // 2. Clear mobile device cache and save fresh registration tokens to MySQL
    async forceFreshMobilePushSubscription(currentUserId) {

        if (this.isEnrollingNotification) return;

        try {
            this.isEnrollingNotification = true;

            // 1. HARD WIPE: Check for any existing service workers and force unregister them
            if ('serviceWorker' in navigator) {
                const activeRegistrations = await navigator.serviceWorker.getRegistrations();

                for (let reg of activeRegistrations) {
                    console.log("Found conflicting service worker thread. Force unregistering...");
                    await reg.unregister(); // This completely drops any locked browser server keys
                }
            }

            // 2. RE-REGISTER: Register a completely clean instance of your service worker file
            console.log("Registering clean service worker instance...");
            const freshRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

            // Ensure the service worker is active and listening
            await navigator.serviceWorker.ready;

            // 3. GENERATE TOKEN: Let Firebase execute a clean token handshake
            const deviceToken = await getToken(this.messaging, {
                vapidKey: "BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE",
                serviceWorkerRegistration: freshRegistration
            });

            this.setState({ userToken: deviceToken, userDeviceToken: deviceToken })

            if (deviceToken) {
                console.log("Firebase cleanly generated mobile token:", deviceToken);

                // 4. DATABASE WRITE: Post the raw token to your corrected PHP save file
                const response = await axios.post(`https://testmembership.bktsystems.com/api/UAT_saveSubscription.php`, {
                    endpoint: deviceToken,
                    body: deviceToken,
                    userid: currentUserId
                });
                // console.log('---', response.data);

                console.log("Database Sync Server Response Details:", response.data);
            }

        } catch (error) {
            console.error("Mobile subscription enrollment dropped safely:", error);
        } finally {
            this.isEnrollingNotification = false;
        }

    }

    sendPushNotif = async (status) => {
        try {

            if (Notification.permission !== "granted") {
                const permission = await Notification.requestPermission();
                if (permission !== "granted") {
                    alert("You must allow notifications in your browser settings to test this!");
                    return;
                }
            }
            let config = {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    title: 'iWash Laundry Notification!',
                    message: 'Please note that your order status has been updated to ' + status,
                    orderstatus: status,
                    userid: this.state.orderdetails[0].customerid

                }
            };
            //  const url = "http://localhost/iwash-php/api/send_push.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_send_push.php";
            // const url = "https://testmembership.bktsystems.com/api/sendNotification_.php";
            // 1. Send text content safely using a POST request body
            const response = await axios.get(url, config);

            console.log('Notification broadcast response:', response.data);
            //  alert('Server processing notifications!');
            if (response.data.success) {
                //  const url = "http://localhost/iwash-php/api/sendNotification.php";
                const titleText = 'iWash-Laundry New Notification!';
                const messageText = 'Please note that your order status has been updated to ' + status + '.';
                // Check if service worker is active to display standard system banners
                if ('serviceWorker' in navigator && 'serviceWorker' in navigator) {
                    console.log("Triggering local notification banner...");

                    const options = {
                        body: messageText,
                        icon: window.location.origin + '/public/iwash-logo.png', // Must be an absolute URL for Chrome
                        badge: window.location.origin + '/public/iwash-logo.png',
                        tag: 'iwash-alert-' + Date.now(), // Unique tag forces a fresh banner to pop up
                        requireInteraction: true // Prevents Chrome from hiding it instantly
                    };
                    // Instantiate directly on the window context to completely bypass the sw.js file
                    const localNotification = new Notification(titleText, options);
                    localNotification.onclick = function (event) {
                        event.preventDefault();
                        window.focus();
                        localNotification.close();
                    };
                }
            }

        } catch (error) {
            console.error('Push notification trigger failed:', error);
        }
    }

    getStatusOptions = (status) => {
        let options = []
        if (status === 'Submitted') {
            options = [
                { label: "Cancelled", value: "Cancelled" },
                { label: "In store", value: "In store" },
                { label: "Processing", value: "Processing" },
            ]
        }
        if (status === 'In store') {
            options = [
                { label: "Cancelled", value: "Cancelled" },
                { label: "Processing", value: "Processing" },
            ]
        }
        if (status === 'Processing') {
            options = [
                { label: "Ready to collect", value: "Ready to collect" },
            ]
        }
        if (status === 'Ready to collect') {
            options = [
                { label: "Collected", value: "Collected" },
                { label: "Delivered", value: "Delivered" }
            ]
        }
        if (status === 'Delivered') {
            options = [
                { label: "Cancelled", value: "Cancelled" },
            ]
        }
        this.setState({ statusOptions: options })
    }
    //  orderstats = getOrderDetails(this.props.location.state.orderid);
    orderstats = []

    componentDidMount = async () => {
       // console.log('----', this.props.location.state.page)
        let orderdetails = await getOrderDetails(this.props.location.state.orderid)
        let strStat = '';
        let user_DeviceToken = ''
        let userDeviceToken = await getUserDeviceToken(orderdetails[0].customerid)
        if (userDeviceToken.length > 0) {
            let rawBodyString = userDeviceToken[0].body;
            let parsedBody = JSON.parse(rawBodyString);
            user_DeviceToken = parsedBody.body;
            this.setState({ userDeviceToken: user_DeviceToken, deviceToken: user_DeviceToken })
        }

        // let strOrders = await getCustomerOrders(this.props.location.state.userid);
        if ((this.props.location.state.page === 'allOrders')|| (this.props.location.state.page ==='dashboardlist')) {document.getElementById('adminOptions').style.display = 'block';}
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {

            // console.log(orderdetails[0].customerid)
            // getOrderStatuses(this.props.location.state.orderid).then(ret => { this.orderstats = ret })
            this.orderstats = await (getOrderStatuses(this.props.location.state.orderid))
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, gender: this.props.location.state.gender, orderid: this.props.location.state.orderid,
                phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, orderdetails: orderdetails, customerid: orderdetails.customerid,
                page: this.props.location.state.page, userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate,

            })
            // ----- Listen for real-time changes using Pusher
            this.pusher = new Pusher('3aecc72fdbc50572baa6', {
                cluster: 'mt1'
            });

            const channel = this.pusher.subscribe('iWash-laundry-631');
            channel.bind('admin-updated', (data) => {
                this.componentDidMount();

            });

            let lastStat = 'Submitted'
            if ((Array.isArray(this.orderstats)) && (this.orderstats.length !== 0)) {
                // console.log(this.orderstats)
                for (let i = 0; i < this.orderstats.length; i++) {
                    strStat += `${this.orderstats[i].status}  | ${this.orderstats[i].modified} \n`
                }
                this.setState({
                    strStats: strStat, laststatus: this.orderstats[this.orderstats.length - 1].status,
                })
                lastStat = this.orderstats[this.orderstats.length - 1].status;
            }
            this.getStatusOptions(lastStat);
        }
        if (strStat.includes("Delivered") || strStat.includes("Collected")) {
            document.getElementById('adminOptions').style.display = 'none'
        }
        //console.log('----'+this.state.strStatIco)
    }

    setOrderStatus = (e) => {
        this.setState({ status: e, selectedOrderStatus: e.label });
    }

    sendPushNotification = async (orderstatus) => {
        let result = "";
        if (this.state.userDeviceToken === '') {
            return
        }
        else {

            console.log('Routing to device token: ', this.state.userDeviceToken);

            try {
                //  const localBackendUrl = "http://localhost/iwash-php/api/send_push.php";
                // const localBackendUrl = "http://localhost/iwash-php/api/checkUserTokenStatus.php"; 
                const localBackendUrl = "https://testmembership.bktsystems.com/api/send_push.php";

                const localPayload = {
                    device_token: this.state.userDeviceToken,
                    orderstatus: orderstatus,
                    firebase_server_key: '' // Pass it if your backend doesn't store it
                };

                const config = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };

                // This hits YOUR server, which you control and can add CORS headers to
                const r_response = await axios.post(localBackendUrl, localPayload, config);
                result = r_response.data
                //  console.log("Detailed Backend Diagnostics:", r_response.data);


            } catch (error) {
                console.error("Direct browser client broadcast channel failed:", error);
                result = error;
            }

        }
        return result

    }

    getStatusIcon = (status) => {
        let icon
        switch (status) {
            case 'Submitted': return `url(${submitIcon})`
            case 'Processing': return `url(${inprogressIcon})`
            case 'Cancelled': return `url(${cancelledIcon})`
            case 'In store': return `url(${submitIcon})`
            case 'Ready to collect': return `url(${readyIcon})`
            case 'Delivered':
            case 'Collected': return `url(${deliveredIcon})`
            default:
                return `url(${submitIcon})`
        }

    }
    goToOrders = (dashboardOrderType, dashboardtype) => {
        this.props.navigate('/orders', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber, dashboardOrderType: dashboardOrderType,
                dashboardtype: dashboardtype, page: this.props.location.state.page,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
            }
        });
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        let navUrl = '';
        if (this.props.location.state.page === 'dashboardlist') {
            this.goToOrders(this.props.location.state.dashboardOrderType, this.props.location.state.dashboardtype);
        }
        if (this.props.location.state.page === 'allOrders') {
            navUrl = 'orders'
        }
        if (this.props.location.state.page === 'trackOrders') {
            navUrl = 'trackorder'
        }
        if (navUrl !== '') {
            this.props.navigate('/' + navUrl, {
                state: {
                    fullname: this.state.fullname, emailaddress: this.state.emailaddress, gender: this.state.gender, phonenumber: this.state.phonenumber,
                    role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, 
                    userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
                }
            });
        }

    }

    handleNotesChange = (e) => {
        this.setState({ notes: e.target.value });
    }

    handleCloseOrderderDetails = () => {
        let navUrl = '';
        if (this.props.location.state.page === 'dashboardlist') {
            this.goToOrders(this.props.location.state.dashboardOrderType, this.props.location.state.dashboardtype);
        }
        if (this.props.location.state.page === 'allOrders') {
            navUrl = 'orders'
        }
        if (this.props.location.state.page === 'trackOrders') {
            navUrl = 'trackorder'
        }
        if (navUrl !== '') {
            this.props.navigate('/' + navUrl, {
                state: {
                    fullname: this.state.fullname, emailaddress: this.state.emailaddress, gender: this.state.gender, phonenumber: this.state.phonenumber,
                    role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender,
                    userstatus: this.state.userstatus, registrationdate: this.state.registrationdate, page: this.props.location.state.page,
                }
            });
        }
    }

    updateOrder = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "db": "iwash_laundry", userid: this.state.userid, orderid: this.state.orderdetails[0]['id'],
                customername: this.state.orderdetails[0]['fullname'],
                status: this.state.selectedOrderStatus, notes: this.state.notes, modifiedby: this.state.fullname
            }
        };
        // console.log('----'+this.state.userid)
        if (this.state.selectedOrderStatus === '') {
            alert('lease select a status!')
            return
        }
        if ((this.state.selectedOrderStatus === 'Cancelled') && (this.state.notes === '')) {
            alert('Please capture the notes to jutify!')
            return
        }
        else {
            //const url = "http://localhost/iwash-php/api/updateOrderStatus.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_updateOrderStatus.php";
            //const url = "https://testmembership.bktsystems.com/api/updateOrderStatus.php";
            const response = await axios.get(url, config);
            // console.log(response.data);
            if (response.data.includes("Success")) {
                // Send push notification 
                await this.sendPushNotification(this.state.selectedOrderStatus);
                let strStat = '';

                let orderstats = await getOrderStatuses(this.props.location.state.orderid);

                if ((orderstats.length !== 0) && (Array.isArray(orderstats))) {
                    for (let i = 0; i < orderstats.length; i++) {
                        strStat += `${orderstats[i].status}  | ${orderstats[i].modified} \n`
                    }
                    this.setState({ strStats: strStat, laststatus: orderstats[orderstats.length - 1].status })
                }
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById("successUpdate").style.display = "block";
                document.getElementById("errorUpdate").style.display = "none";

            } else {
                document.getElementById("errorUpdate").style.display = "block";
            }
        }
        if (this.state.userDeviceToken !== '') {
            let notifres = await this.sendPushNotification(this.state.selectedOrderStatus);
            //  console.log(notifres.http_status)
            if (notifres.http_status === 404) {
                await this.forceFreshMobilePushSubscription(this.state.orderdetails[0].customerid);
                await this.sendPushNotification(this.state.selectedOrderStatus);
            }
        }
        await handleRealTimeUpdate();
        this.setState({ selectedOrderStatus: '', status: '', notes: '', strStats: '' });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined ||
            this.props.location.state.orderid === null || this.props.location.state.orderid === undefined) {
            return <Navigate to="/" replace />;
        }
        // console.log(this.state.orderdetails.fullname);
        return (
            <>
                <div style={{ height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily: "lora" }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "5px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span> */}
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "1vh" }}>
                        <span variant="primary" style={{
                            border: "none", width: "60px",
                            paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "80%", borderRadius: "10px",
                        }} onClick={this.goBackToMenu}>
                            <span style={{
                                textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px"
                            }}><ArrowLeft color="darkblue" size={40} /> <label>{this.state.laststatus}</label></span>

                        </span>
                    </div>
                    <div style={{
                        paddingTop: "13vh", border: '2px solid #f0eee4', borderRadius: "10px", height: '80%', width: "100%",
                        // backgroundImage: `url(${submitIcon})`, backgroundSize: '100%', backgroundRepeat: "no-repeat", backgroundPosition: 'center',
                        backgroundImage: this.getStatusIcon(this.state.laststatus), backgroundSize: '100% 100%', backgroundRepeat: "no-repeat", backgroundPosition: 'center',
                    }}></div>
                    <div style={{ paddingBottom: "10px", width: "100%", border: "1px solid lightgray", borderRadius: "10px", padding: "10px" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", borderRadius: "10px", color: "darkblue", borderBottom: "2px solid darkblue" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#f0eee4", color: "darkblue", borderBottom: "2px solid darkblue" }}>
                                    <th style={{ padding: "10px", border: "1px solid darkblue" }}>Record</th>
                                    <th style={{ padding: "10px", border: "1px solid darkblue" }}>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.orderdetails.map((detail) => {
                                    return (
                                        <>
                                            <tr>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>Order ID</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.id}</td>
                                            </tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Full Name</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.fullname}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Phone Number</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.phonenumber}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Email Address</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.emailaddress}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Address</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.address}, {detail.area} </td></tr>
                                            {/* <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Area</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.area}</td></tr> */}
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Service Type</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.servicetype}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Date Submitted</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.modified}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Date of Service</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.servicedate}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Weight</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.loadweight}</td></tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Comments</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue" }}>{detail.notes}</td>
                                            </tr><tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Total Amount</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue", fontWeight: "bold" }}>R{detail.totalamount}</td>
                                            </tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Submitted by</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue", whiteSpace: 'pre-line' }}>
                                                    <Label style={{ fontWeight: "bold", fontStyle: "italic" }}>{detail.modifiedby === detail.fullname || detail.modifiedby === "" ? 'Self' : detail.modifiedby}</Label></td>
                                            </tr>
                                            <tr><td style={{ padding: "5px", border: "1px solid darkblue" }}>Status</td>
                                                <td style={{ padding: "5px", border: "1px solid darkblue", whiteSpace: 'pre-line' }}>
                                                    <Label >{detail.status} | {detail.modified}<br />{this.state.strStats}</Label></td>
                                            </tr>
                                            {(() => {
                                                //     this.getthisOrderDetails(detail.id);
                                                //  this.setState = ({ customername: detail.fullname, customerid: detail.customerid })
                                            })()}
                                        </>
                                    );

                                })}
                            </tbody>
                        </table>

                        <div id='adminOptions' style={{ display: "none" }}>
                            <FormGroup style={{ paddingTop: "20px" }}>
                                <Label for='country' style={{ color: "#666", fontStyle: "italic" }}>Select status</Label>
                                <Select
                                    options={this.state.statusOptions}
                                    maxMenuHeight="100%"
                                    onChange={(e) => this.setOrderStatus(e)}
                                    value={this.state.status}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Label for="notes" style={{ color: "#666", fontStyle: "italic" }} >Add notes/comments</Label>
                                <Input
                                    type="textarea"
                                    id="notes"
                                    name="notes"
                                    required={true}
                                    rows="2"
                                    value={this.state.notes}
                                    onChange={this.handleNotesChange}
                                />
                            </FormGroup>
                            <div id="successUpdate" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold" }}>
                                <FormGroup>
                                    <Label>Order status has been successfully updated! &#128591;</Label>
                                </FormGroup>
                            </div>
                            <div id="errorUpdate" style={{ display: "none", textAlign: "center", color: "red", fontWeight: "bold" }}>
                                <FormGroup>
                                    <Label>Sorry, there was an error updating the order. Please try again &#128533;</Label>
                                </FormGroup>
                            </div>
                            <div id="btnSubmit" style={{ paddingTop: "10px" }}>
                                <Button style={{ backgroundColor: "rgba(30, 104, 40, 1)", height: "60px", width: "100%", color: 'white', fontWeight: "bold" }}
                                    onClick={this.updateOrder}>Update Order</Button>
                            </div>
                        </div>
                        <div id="btnCloseOrderDetailsForm" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                            <Button style={{ width: "100%", fontWeight: "bold", height: "60px" }}
                                onClick={this.handleCloseOrderderDetails} color="danger">
                                Close
                            </Button>
                        </div>
                    </div>
                    <data style={{ display: "none" }} id="orderdetails">{JSON.stringify(this.state.orderdetails)}</data>
                </div>
            </>
        );

        <div className="footer-content" style={{
            paddingTop: "10%", marginTop: "auto", padding: "10px", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666",
            backgroundColor: "#f0eee4", position: "fixed", bottom: "0", width: "100%", height: "60px",
        }}>
            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
            <div className="footer-links">
                <Button style={{
                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                    fontWeight: "bold", textDecoration: "underline"
                }}
                    onClick={this.openAbout}>About Us
                </Button>
                | <a href="https://wa.me/+27796372245" target="_blank" rel="noreferrer" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

            </div>
        </div>
    }

}
export default withNavigateHook(Orderdetails);
